import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../../guards/auth.guard';
import { RoleGuard } from '../../guards/role.guard';
import { FnPaymentsOngoingComponent } from './components/fn-payments-ongoing/fn-payments-ongoing.component';
import { FnProvidersAccountsComponent } from './components/fn-providers-accounts/fn-providers-accounts.component';
import { FnBusinessPaydoneComponent } from './views/fn-business-finance/fn-business-paydone.component';
import { FnMyFinanceComponent } from './views/fn-my-finance/fn-my-finance.component';
import { FnPayInvoicesComponent } from './components/fn-pay-invoices/fn-pay-invoices.component';
import { FnConsolidatedComponent } from './components/fn-consolidated/fn-consolidated.component';
import { FnConsolidatedDetailsComponent } from './components/fn-consolidated-details/fn-consolidated-details.component';
import { FnPaidOrdersComponent } from './views/fn-paid-orders/fn-paid-orders.component';
import { FnManagePayOrdersComponent } from './views/fn-manage-pay-orders/fn-manage-pay-orders.component';

const routes: Routes = [
  {
    path: 'my-finance',
    component: FnMyFinanceComponent,
    data: {
      title: 'IP.SIDENAV.OPTIONS.MY_FINANCE',
      allowedRole: ['business', 'provider'],
    },
    canActivateChild: [RoleGuard, AuthGuard],
  },
  {
    path: 'payments-ongoing',
    component: FnPaymentsOngoingComponent,
    data: {
      title: 'IP.SIDENAV.OPTIONS.FINANCES_OPTIONS.PAYMENTS_ONGOING',
      allowedRole: ['business'],
    },
    canActivateChild: [RoleGuard, AuthGuard],
  },
  {
    path: 'payments-done',
    component: FnBusinessPaydoneComponent,
    data: {
      title: 'IP.SIDENAV.OPTIONS.FINANCES_OPTIONS.PAYMENTS_DONE',
      allowedRole: ['business'],
    },
    canActivateChild: [RoleGuard, AuthGuard],
  },
  {
    path: 'pay-invoices',
    component: FnPayInvoicesComponent,
    data: {
      title: 'IP.SIDENAV.OPTIONS.PAY_INVOICES',
      allowedRole: ['business', 'create_pay_orders'],
    },
    canActivateChild: [RoleGuard, AuthGuard],
  },
  {
    path: 'generated-orders',
    component: FnConsolidatedComponent,
    data: {
      title: 'IP.SIDENAV.OPTIONS.CONSOLIDATED',
      allowedRole: ['business', 'manage_pay_orders', 'create_pay_orders'],
    },
    canActivateChild: [RoleGuard, AuthGuard],
  },
  {
    path: 'paid-orders',
    component: FnPaidOrdersComponent,
    data: {
      title: 'IP.SIDENAV.OPTIONS.CONSOLIDATED',
      allowedRole: ['business', 'manage_pay_orders', 'create_pay_orders'],
    },
    canActivateChild: [RoleGuard, AuthGuard],
  },
  {
    path: 'manage-pay-orders',
    component: FnManagePayOrdersComponent,
    data: {
      title: 'IP.SIDENAV.OPTIONS.CONSOLIDATED',
      allowedRole: ['business', 'manage_pay_orders'],
    },
    canActivateChild: [RoleGuard, AuthGuard],
  },
  {
    path: 'consolidated-detail',
    component: FnConsolidatedDetailsComponent,
    data: {
      title: 'IP.SIDENAV.OPTIONS.CONSOLIDATED',
      allowedRole: ['business', 'manage_pay_orders', 'create_pay_orders'],
    },
    canActivateChild: [RoleGuard, AuthGuard],
  },
  {
    path: 'provider-accounts',
    component: FnProvidersAccountsComponent,
    data: {
      title: 'IP.SIDENAV.OPTIONS.FINANCES_OPTIONS.PROVIDER_ACCS',
      allowedRole: ['business'],
    },
    canActivateChild: [RoleGuard, AuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FinanceRoutingModule {}
